import { useState, useEffect } from "react";
import { DeviceType, useDeviceType } from "./useDeviceType";

export const useIsElementActive = (ref: React.RefObject<HTMLElement>) => {
  const [isActive, setIsActive] = useState(false);
  const deviceType = useDeviceType();
  const isTouchScreenDevice = deviceType === DeviceType.Mobile || deviceType === DeviceType.Tablet;
  const startEvent = isTouchScreenDevice ? "touchstart" : "mousedown";
  const stopEvent = isTouchScreenDevice ? "touchend" : "mouseup";

  useEffect(() => {
    const handleStart = () => {
      setIsActive(true);
    };

    const handleEnd = () => {
      setIsActive(false);
    };

    if (ref == null) return;
    const element = ref.current;

    if (element) {
      element.addEventListener(startEvent, handleStart);
      element.addEventListener(stopEvent, handleEnd);

      if (isTouchScreenDevice) {
        element.addEventListener("touchcancel", handleEnd);
        element.addEventListener("touchmove", handleEnd);
      }
    }

    return () => {
      if (element) {
        element.removeEventListener(startEvent, handleStart);
        element.removeEventListener(stopEvent, handleEnd);
        element.removeEventListener("touchcancel", handleEnd);
        element.removeEventListener("touchmove", handleEnd);
      }
    };
  }, [isTouchScreenDevice, ref, startEvent, stopEvent]);

  return isActive;
};
